export default import.meta.ROLLDOWN_FILE_URL_nmaWwMD08Rn0RjNBWDO4Xw